/**
 * @file: console平台其他接口
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-11-29 17:46:27
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2023-12-05 10:29:25
 * @FilePath: /console-znzs/new_src/api/console.js
 */

import Vue from 'vue';
import axios from 'axios';
import Cookies from 'js-cookie';
import {isUndefined} from 'lodash-es';

const consoleServer = axios.create({
    baseURL: '/api',
    timeout: 60000,
});

consoleServer.interceptors.request.use(config => {
    config.headers.csrftoken = Cookies.get('bce-user-info');
    config.headers['X-Region'] = config.headers['X-Region'] || 'global';
    config.headers['X-Request-By'] = config.headers['X-Request-By'] || 'RestClient';
    return config;
});

consoleServer.interceptors.response.use(response => {
    const responseData = response.data;
    // 支持queryGroupResourcePoly的特殊情况
    const judgeKey = response.config.judgeKey || '';
    if (judgeKey && !isUndefined(responseData[judgeKey])) {
        return responseData;
    }
    if (responseData.success === true || responseData.status === 0) {
        return responseData;
    }

    Vue.prototype.$notify.warning({
        message: '抱歉，网络好像出问题了，请重试！',
        duration: 5000,
    });

    return Promise.reject(responseData);
}, err => {
    Vue.prototype.$notify.warning({// 全局配置网络问题响应
        message: '抱歉，网络好像出问题了，请刷新重试！',
        duration: 5000,
    });
    return Promise.reject(err);
});

/**
 * 查询所有区域实例数
 * @param {*} query
 * @returns
 */
export const queryInstanceCount = () => consoleServer.get(
    '/bcc_global/over_view/instance?region=global&locale=zh-cn&_=' + Date.now()
);

/**
 * 查询BCC实例列表
 * @returns
 */
export const queryInstanceList = (query, region) => consoleServer.post(
    '/bcc/instance/list?locale=zh-cn&_=' + Date.now(),
    {
        ...query,
        enableBid: true,
        isAdvancedSearch: false,
        order: 'desc',
        orderBy: 'createTime',
        pageSize: 10,
        serverType: 'BCC',
    }, {
        headers: {
            'X-Region': region,
        },
    });

/**
 * 查询短信签名申请列表
 * @returns
 */
export const querySignatureApplyList = query => consoleServer.post('smsv3/signature?locale=zh-cn&_=' + Date.now(), {
    ...query,
    countryType: 'DOMESTIC',
    pageSize: 10,
});
/**
 * 查询模版申请列表
 * @returns
 */
export const queryTemplateApplyList = query => consoleServer.post('smsv3/template?locale=zh-cn&_=' + Date.now(), {
    ...query,
    countryType: 'DOMESTIC',
    pageSize: 10,
});

/**
 * 切换地域
 * @param {*} regionId
 * @returns
 */
export const setRegion = regionId => consoleServer.post('/region/set?locale=zh-cn', {
    regionId,
}, {
    headers: {
        'X-Region': regionId,
        'X-Request-By': 'ERApplication',
    },
});

/**
 * 获取BCC实例列表
 * @param {*} data
 * @returns
 */
export const getBCCInstance = instance => consoleServer.post(
    '/bcc/instance/list',
    {
        filters: [{
            keywordType: 'fuzzySearch',
            subKeywordType: '',
            keyword: instance?.keyword
                || instance?.instanceId
                || instance?.name
                || instance?.instanceName
                || '',
        }],
        enableBid: true,
        isAdvancedSearch: true,
        keywordType: 'fuzzySearch',
        order: 'desc',
        orderBy: 'createTime',
        pageNo: 1,
        pageSize: 20,
        serverType: 'BCC',
    },
    {
        headers: {
            'X-Region': instance.region,
        },
    }
);

/**
 * 查询BCD域名列表
 */
export const getBcdDomains = instance => consoleServer.post(
    '/bcd/resources/list',
    {
        domainNameFuzzy: (instance.keyword || '').trim(),
        expireTimeStart: '2011-11-01 00:00:00',
        expireTimeEnd: '2033-11-01 23:59:59',
        pageNo: 1,
        pageSize: 10,
    }
);

/**
 *  获取BLB实例列表
 * @param {*} instance
 * @returns
 */
const getBlbInstance = instance => consoleServer.post('/blb/instance/list', {
    keywordType: 'fuzzySearch',
    blbType: instance.blbType,
    keyword: instance?.keyword || '',
    eipPurchaseType: '',
    pageNo: 1,
    pageSize: 10,
    regions: instance.region,
}, {
    headers: {
        'X-Region': instance.regions,
    },
});
/**
 * 查询BLB应用型实例
 * @param {*} instance
 * @returns
 */
export const getBlbInstanceList = instance => consoleServer.post('/blb/cluster/allBlbList', {
    keywordType: 'fuzzySearch',
    region: instance.region,
    keyword: instance?.keyword || '',
    pageNo: 1,
    pageSize: 10,
}, {
    headers: {
        'X-Region': instance.region,
    },
});

/**
 * 查询BIP弹性公网IP
 */
export const getEIPList = instance => consoleServer.post(
    '/eip/list',
    {
        keyword: instance.keyword || '',
        keywordType: 'fuzzySearch',
        pageNo: 1,
        pageSize: 10,
        region: instance.region,
    },
    {
        headers: {
            'X-Region': instance.region,
        },
    }
);
/**
 * 查询BIP弹性公网IP
 */
export const getLSList = instance => consoleServer.post(
    '/v1/ls/list',
    {
        keyword: instance?.keyword
                || instance?.instanceName
                || '',
        keywordType: 'name',
        order: 'desc',
        orderBy: 'expireTime',
        pageNo: 1,
        pageSize: 20,
        region: instance?.region,
    },
    {
        headers: {
            'X-Region': instance.region,
            commonErrorCatch: false,
        },
    }
);

/**
 * 获取用户站点信息，aipage团队的接口，直接调用的
 */
export const getAIPageSiteList = () => consoleServer.get('/aipage/site/gdSiteList', {params: {
    page: 1,
    perPage: 9999,
}}).then(res => {
    if (res.status === 0) {
        return {
            success: true,
            page: {
                result: res.data?.rows,
            },
        };
    }
    return {
        success: false,
    };
}).catch(() => {
    return {
        success: false,
    };
});

// 根据三级类型获取工单配置侧模板
export const getTemplateByFeatureId = featureId => consoleServer.post('/ticket/v1/feature/template', {
    featureId,
});

/**
 * 查询全部资源分组
 * @returns
 */
export const queryGroupResourcePoly = () => consoleServer.get('/res/resource', {
    params: {
        queryGroupResourcePoly: '',
        locale: 'zh-CN',
        _: Date.now(),
        groupId: 'query_all_groups',
    },
    judgeKey: 'products',
});

// 获取console的区域设定
export const getAvailableRegion = () => consoleServer.post('/region/available?locale=zh-cn');

/**
 * 分页查询资源列表（queryResourcePageV2）
 * @param {Object} query 查询参数
 * @param {string} region 区域
 * @returns {Promise}
 */
export const queryResourcePageV2 = (query = {}) => consoleServer.post(
    '/res/resource?locale=zh-cn&_=' + Date.now() + '&queryResourcePageV2=',
    {
        regions: [],
        serviceTypes: [],
        resourceTypes: [],
        resourceName: '',
        resourceId: '',
        pageNo: 1,
        pageSize: 10,
        groupId: '',
        queryResourcePageV2: true,
        ...query,
    },
    {
        judgeKey: 'resources',
        headers: {
            // 根据抓包，全部为bj
            'X-Region': 'bj',
        },
    }
);

const commonHeader = {
    judgeKey: 'resources',
    headers: {
        // 根据抓包，全部为bj
        'X-Region': 'bj',
    },
};

/**
 * 查询当前账户可退金额
 */
export const queryRefundSource = () => consoleServer.post('/invoice/pool/list?locale=zh-cn&_=' + Date.now(),
    {
        params: {},
    },
    commonHeader
);

/**
 * 查询服务名称
 */
export const queryServiceName = billType => consoleServer.post('/invoice/taxCode/list?locale=zh-cn&_=' + Date.now(),
    {
        billType,
    },
    commonHeader
);

/**
 * 查询开票产品
 */
export const queryProductType = (billType, taxCodes) => consoleServer.post(
    '/invoice/service/list?locale=zh-cn&_=' + Date.now(),
    {
        billType,
        taxCodes,
    },
    commonHeader
);

/**
 * 查询自定义开票的数组
 * @param {
 * billType:string,
 * serverTypes:Array,
 * taxCodes:Array
 * } data
 * @returns
 */
export const queryDiyArr = data => consoleServer.post('/invoice/bill/max/amount?locale=zh-cn&_=' + Date.now(),
    {
        billType: data.billType || 'COMMON',
        serviceTypes: data.serviceTypes || [],
        taxCodes: data.taxCodes || [],
    },
    commonHeader
);

/**
 * 查询发票信息页面所需数据
 * @returns
 */
export const queryInformation = () => consoleServer.post('/invoice/template/detail?locale=zh-cn&_=' + Date.now(),
    {},
    commonHeader
);

/**
 * 查询用户邮箱
 */
export const queryUserEmail = () => consoleServer.post('/invoice/digital/user/avail?locale=zh-cn&_=' + Date.now(),
    {},
    commonHeader
);

/**
 * 发起开发票请求
 */
export const startInvoiceQue = data => consoleServer.post('/invoice/apply/params/save?locale=zh-cn&_=' + Date.now(),
    {
        ...data,
        selectAll: false,
    },
    commonHeader
);

/**
 * 获取当前的历史账单信息
 */
export const queryHistoryInfo = data => consoleServer.post('/invoice/apply/summary?locale=zh-cn&_=' + Date.now(),
    {
        ...data,
        selectAll: false,
    },
    commonHeader
);

/**
 * 上报发票基本信息
 */
export const submitInvoiceBasicInfo = data => consoleServer.post('/invoice/template/edit?locale=zh-cn&_=' + Date.now(),
    data,
    commonHeader
);

/**
 * 上报发票内容
 */
export const submitInvoiceInfo = data => consoleServer.post('/invoice/apply/v2?locale=zh-cn&_=' + Date.now(),
    data,
    commonHeader
);

/**
 * 查询刚才开具的发票内容
 */
export const queryLastinvoic = data => consoleServer.post('/invoice/list?locale=zh-cn&_=' + Date.now(),
    {
        ...data,
        order: 'desc',
        orderBy: 'ctime',
        pageNo: 1,
        pageSize: 1,
    },
    commonHeader
);

/**
 * 查询订单的具体详情
 */
export const queryInvoicById = invoiceId => consoleServer.post('/invoice/detail/summary?locale=zh-cn&_=' + Date.now(),
    {
        invoiceId,
    },
    commonHeader
);

/**
 * 查询可开票订单/账单列表
 * @param {*} data
 * @returns
 */
export const queryRefundTicketList = data => consoleServer.post('/invoice/apply/bill/list?locale=zh-cn&_=' + Date.now(),
    data,
    commonHeader
);